import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "max-w-screen-sm mx-auto w-full px-8 mt-8",
  id: "voucher"
}
const _hoisted_2 = {
  ref: "voucher",
  class: "bg-gray-500 py-3 px-3",
  id: "voucher-printer"
}
const _hoisted_3 = { class: "hidden" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-between mt-4 text-black px-3"
}
const _hoisted_5 = { class: "text-sm font-semibold" }
const _hoisted_6 = { class: "font-semibold text-xl" }
const _hoisted_7 = {
  key: 2,
  class: "max-w-96 w-full mx-auto relative p-2 mt-4"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" printer  "),
    _createElementVNode("div", _hoisted_2, _cache[2] || (_cache[2] = [
      _createElementVNode("div", { class: "h-4 bg-black w-full" }, null, -1 /* CACHED */)
    ]), 512 /* NEED_PATCH */),
    _createElementVNode("div", {
      class: _normalizeClass(["px-6 overflow-hidden relative pb-2", $data.showVoucher ? '-mt-6 pt-6 pb-8' : 'h-16'])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-col justify-center overflow-hidden absolute z-0 inset-x-4", { 'opacity-0': $data.showVoucher, '': !$data.showVoucher }])
      }, [
        _createElementVNode("button", {
          class: "max-w-96 w-full mx-auto relative p-2 mt-4 animate-bounce",
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.generateVoucher && _ctx.generateVoucher(...args)))
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("img", {
            src: "/img/button-shop.png",
            class: "absolute inset-0 w-full h-full z-0"
          }, null, -1 /* CACHED */),
          _createElementVNode("div", { class: "border-2 border-white rounded-md text-center relative z-10" }, [
            _createElementVNode("p", { class: "text-lg flex justify-center items-center gap-1 text-white font-semibold" }, "Generar Voucher")
          ], -1 /* CACHED */)
        ]))
      ], 2 /* CLASS */),
      _createCommentVNode(" voucher "),
      _createElementVNode("div", {
        class: _normalizeClass(["bg-gradient-to-t from-white to-[#E2E8F0] -mt-6 drop-shadow-md px-2 flex flex-col justify-center overflow-hidden transition-all duration-500 ease-out transform voucher-shadow", { 'py-4': $data.showVoucher, '-translate-y-[150%]': !$data.showVoucher, 'h-0': !$data.showVoucher }])
      }, [
        _cache[8] || (_cache[8] = _createElementVNode("img", {
          src: "/img/logo-recibo.png",
          alt: "",
          class: "w-16 mx-auto"
        }, null, -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_3, _toDisplayString($data.counter), 1 /* TEXT */),
        _createCommentVNode(" item "),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.categories, (category) => {
          return (_openBlock(), _createElementBlock("div", {
            key: category.id
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.products, (product) => {
              return (_openBlock(), _createElementBlock("div", {
                key: product.id
              }))
            }), 128 /* KEYED_FRAGMENT */)),
            _createCommentVNode(" end item ")
          ]))
        }), 128 /* KEYED_FRAGMENT */)),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "w-full mt-8 flex justify-center" }, [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "233",
            height: "2",
            viewBox: "0 0 233 2",
            fill: "none"
          }, [
            _createElementVNode("path", {
              opacity: "0.5",
              d: "M1 1H232",
              stroke: "#64748B",
              "stroke-linecap": "round"
            })
          ])
        ], -1 /* CACHED */)),
        ($data.shopLength > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-sm font-semibold" }, "Subtotal:", -1 /* CACHED */)),
              _createElementVNode("p", _hoisted_5, [
                _cache[4] || (_cache[4] = _createTextVNode(" s/. ")),
                _createElementVNode("span", _hoisted_6, _toDisplayString(($options.calculateSubtotal() / 100).toFixed(2)), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($data.shopLength > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "max-w-96 w-full mx-auto relative p-2 mt-4",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('open-form')))
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("div", { class: "border-2 border-white rounded-md text-center relative z-10" }, [
                _createElementVNode("p", { class: "text-lg flex justify-center items-center gap-1 text-white font-semibold" }, "Finalizar Compra")
              ], -1 /* CACHED */)
            ])))
          : _createCommentVNode("v-if", true),
        ($data.shopLength == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[7] || (_cache[7] = [
              _createElementVNode("div", { class: "bg-black border-2 border-white rounded-md text-center relative z-10" }, [
                _createElementVNode("p", { class: "flex justify-center items-center gap-1 text-white font-semibold py-1" }, "Add products to your quote")
              ], -1 /* CACHED */)
            ])))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ]))
}